export var RouteNames;
(function (RouteNames) {
    RouteNames["Landing"] = "landing";
    RouteNames["Home"] = "home";
    RouteNames["Kyc"] = "kyc";
    RouteNames["Transact"] = "transact";
    RouteNames["Auth"] = "auth";
    RouteNames["Payment"] = "payment";
    RouteNames["Transaction"] = "transaction";
    RouteNames["AllTransactions"] = "transactions";
    RouteNames["Profile"] = "profile";
    RouteNames["Sell"] = "sell";
    RouteNames["TransactionLimit"] = "limit";
    RouteNames["SellSummary"] = "sellSummary";
    RouteNames["PayoutAccounts"] = "payout-accounts";
    RouteNames["Authorize"] = "authorize";
})(RouteNames || (RouteNames = {}));
export var RoutePaths;
(function (RoutePaths) {
    RoutePaths["Landing"] = "/landing";
    RoutePaths["Home"] = "/";
    RoutePaths["Kyc"] = "/kyc";
    RoutePaths["Transact"] = "/transact";
    RoutePaths["Auth"] = "/auth";
    RoutePaths["Payment"] = "/payment";
    RoutePaths["Transaction"] = "/transaction";
    RoutePaths["AllTransactions"] = "/transactions";
    RoutePaths["Profile"] = "/profile";
    RoutePaths["Sell"] = "/sell";
    RoutePaths["TransactionLimit"] = "/limit";
    RoutePaths["SellSummary"] = "/sellSummary";
    RoutePaths["PayoutAccounts"] = "/payout-accounts";
    RoutePaths["Authorize"] = "/authorize";
})(RoutePaths || (RoutePaths = {}));
// Routes reachable without a signed in user (partner verification is still required).
export const unprotectedRoutes = [
    RouteNames.Transact,
    RouteNames.Sell,
    RouteNames.Auth,
    RouteNames.Landing,
    RouteNames.SellSummary,
    RouteNames.Authorize,
];
export default { RouteNames, RoutePaths, unprotectedRoutes };
